import { render } from "./ConfigLiveData.vue?vue&type=template&id=4b00d50e"
import script from "./ConfigLiveData.vue?vue&type=script&lang=js"
export * from "./ConfigLiveData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__